import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';
import { DelayShow } from '~js/components/delay-show';
import { TargetReferrer } from '~js/components/target-referrer';
import { PopupCookie } from '~js/components/popup-cookie';
import { a11y } from '~js/components/a11y';

export class LargePopup {
  constructor(el) {
    this.popupContainer = el;
    this.popup = this.popupContainer.querySelector(s.selectors$d.largePromoInner);
    this.popupBody = this.popup.querySelector(s.selectors$d.popupBody);
    this.popupId = this.popup.id;
    this.close = this.popup.querySelector(s.selectors$d.popupClose);
    this.underlay = this.popup.querySelector(s.selectors$d.popupUnderlay);
    this.form = this.popup.querySelector(s.selectors$d.newsletterForm);
    this.cookie = new PopupCookie(this.popupContainer.dataset.cookieName, 'user_has_closed');
    this.isTargeted = new TargetReferrer(this.popupContainer);
    this.a11y = a11y;

    this.init();
  }

  init() {
    const cookieExists = this.cookie.read() !== false;

    if (!cookieExists || window.Shopify.designMode) {
      if (!window.Shopify.designMode) {
        new DelayShow(this.popupContainer, this.popup);
      } else {
        this.showPopup();
      }

      if (this.form) {
        setTimeout(() => {
          if (this.form.classList.contains(c.classes$b.success)) {
            this.showPopupIfNoCookie();
            activePopups -= 1;
          }
        });
      }

      this.initClosers();
    }
  }

  checkPopupTarget() {
    const targetMobile = this.popup.parentNode.classList.contains(c.classes$b.mobile);
    const targetDesktop = this.popup.parentNode.classList.contains(c.classes$b.desktop);

    if (
      (targetMobile && window.innerWidth >= theme.sizes.small) ||
      (targetDesktop && window.innerWidth < theme.sizes.small)
    ) {
      return false;
    } else {
      return true;
    }
  }

  showPopupIfNoCookie() {
    this.showPopup();
  }

  initClosers() {
    this.close.addEventListener('click', this.closePopup.bind(this));
    this.underlay.addEventListener('click', this.closePopup.bind(this));
    this.popupContainer.addEventListener('keyup', (event) => {
      if (event.code === theme.keyboardKeys.ESCAPE) {
        this.closePopup(event);
      }
    });
  }

  closePopup(event) {
    event.preventDefault();
    this.hidePopup();
    this.cookie.write();
  }

  scrollLock() {
    this.resetScrollUnlock();
    this.a11y.trapFocus({
      container: this.popupBody,
    });
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.popupBody }));
  }

  scrollUnlock() {
    this.resetScrollUnlock();

    // Unlock scrollbar after popup animation completes
    scrollLockTimer = setTimeout(() => {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }, 300);
  }

  resetScrollUnlock() {
    if (scrollLockTimer) {
      clearTimeout(scrollLockTimer);
    }
  }

  showPopup() {
    const isTargetValid = this.checkPopupTarget() === true;
    const popupElement = { id: this.popupId, body: this.popup };
    popups.push(popupElement);
    if (isTargetValid) {
      activePopups += 1;
      this.popup.classList.add(c.classes$b.visible);
      this.scrollLock();
    }
  }

  hidePopup() {
    this.popup.classList.remove(c.classes$b.visible);
    const popupIndex = popups.findIndex((x) => x.id === this.popupId);
    activePopups -= 1;
    popups.splice(popupIndex, 1);

    if (activePopups == 1 && document.body.classList.contains(c.classes$b.barIsVisible)) {
      this.scrollUnlock();
    } else if (activePopups < 1) {
      this.scrollUnlock();
      this.a11y.removeTrapFocus();
    } else if (popups.length > 0) {
      const nextPopup = popups[popups.length - 1].body;
      this.a11y.trapFocus({
        container: nextPopup,
      });
    }
  }

  onBlockSelect(evt) {
    if (this.popupContainer.contains(evt.target) && !this.popup.classList.contains(c.classes$b.visible)) {
      this.popup.classList.add(c.classes$b.selected);
      this.popupContainer.classList.add(c.classes$b.hasBlockSelected);
      this.showPopup();
    }
  }

  onBlockDeselect(evt) {
    if (this.popupContainer.contains(evt.target)) {
      this.popup.classList.remove(c.classes$b.selected);
      this.popupContainer.classList.remove(c.classes$b.hasBlockSelected);
      this.hidePopup();
    }
  }

  onUnload() {
    this.scrollUnlock();
  }

  onDeselect() {
    this.popup.classList.remove(c.classes$b.selected);
    this.popupContainer.classList.remove(c.classes$b.hasBlockSelected);
    this.hidePopup();
  }
}